import { Checkbox, FormControlLabel, Grid, Paper } from '@mui/material';
import { CertificationFormVM } from 'civil-status/view-models/document-birth-form';
import { useFormikContext } from 'formik';
import { Fragment, memo } from 'react';

const PaymentComponent = (): React.ReactElement => {
  const formContext = useFormikContext<CertificationFormVM>();

  return (
    <Fragment>
      <Paper elevation={3} className="pmi-px-3 pmi-pb-2">
        <Grid
          item
          xs={12}
          container
          spacing={2}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  id="certificate-intern"
                  disabled
                  checked={formContext.values.flagInternal || false}
                  inputProps={{ 'aria-label': 'Certificato ad uso interno' }}
                />
              }
              label="Certificato ad uso interno"
            />
          </Grid>
          <Grid item xs={6} display="flex" justifyContent="flex-end">
            <div>
              Totale da pagare: <b>{`${formContext.values?.total?.toFixed(2) || '0,00'}€`}</b>
            </div>
          </Grid>
        </Grid>
      </Paper>
    </Fragment>
  );
};

PaymentComponent.displayName = 'Payment Form component';

const Payment = memo(PaymentComponent);

export default Payment;
